<template lang="pug">
	modal(:max-width="1600")
		.card.text-left
			.card-header.bg-info
				span.fa.fa-plus-square.mr-2
				| Insertar originales
				button.close(@click="cerrar") &times;
			.contenedor
				.barraLateral
					div
						h5
							span.fa.fa-user.mr-2
							b {{contrato.ClienteNombre}}
						hr
						.form-group
							label 
								b Fecha creación
							.input-group.input-group-sm
								.input-group-prepend
									.input-group-text Desde
								datepicker(
									v-model="filtro.FechaDesde"
									:monday-first="true"
									inputClass="form-control form-control-sm"
								)
							.input-group.input-group-sm.mt-2
								.input-group-prepend
									.input-group-text Hasta
								datepicker(
									v-model="filtro.FechaHasta"
									:monday-first="true"
									inputClass="form-control form-control-sm"
								)
						hr
						.form-group
							label Filtro
							input.form-control.form-control-sm(placeholder="ID fichero o nombre", v-model="filtro.Cadena")
						button.btn.btn-sm.btn-primary(@click="buscarOriginales")
							span.fa.fa-search.mr-2
							| Buscar
					div.mt-2.mb-0.p-2.bg-dark.text-white
						span.fa.fa-list.mr-2
						| Originales
					div.contieneFicheros
						table.tablaOriginales
							tbody
								tr(
									v-for="original in listadoFicheros"
									:key="original.FicheroID"
								)
									td.p-1 {{original.FicheroID}} - {{original.Nombre}}
									td.p-1.text-right(style="width: 30px;")
										button.btn.btn-sm.btn-warning(@click="agregarOriginal(original)")
											span.fa.fa-caret-right
				.contenidoCentral
					ul.barraOpciones
						li(:class="!originalSeleccionado ? 'disabled' : ''", title="Seleccionar días de inserción", @click="setFechas()")
							span.fa.fa-calendar
						li(:class="!originalSeleccionado ? 'disabled' : ''", title="Particularizar parámetros de colocación", @click="setColocacion()")
							span.fa.fa-cubes
					.table-responsive
						table.table.table-striped.m-0(style="width:100%;")
							thead
								tr.bg-dark.text-white
									th Días
									th Ref ext.
									th FicheroID
									th Descripcion
									th Ins
									th Precio
									th Recargo
									th Dto (%)
									th Contenido
									th Programa
									th H. Inicio
									th H. Fin
									th Posición
									th Fijar
									th Precio final
							tbody
								tr.filaOriginal(
									v-for="original in linea.originales"
									:key="original.OriginalID"
									:class="originalSeleccionado === original ? 'bg-warning' : ''"
									@click="originalSeleccionado = original"
									@keypress.delete="eliminarOriginal(original)"
								)
									td {{ original.dias.length }}
									td
										input.inline(v-model="original.RefExterna")
									td {{ original.FicheroID }}
									td(style="max-width: 150px;")
										.descripcion {{ original.Descripcion }}
									td
										input.inline(v-model.number="original.Inserciones", size="2", @focus="seleccionarTodo($event)", @keyup="calculaImportes")
									td
										input.inline(v-model.number="original.Importe", size="6", @focus="seleccionarTodo($event)", @keyup="calculaImportes")
									td
										input.inline(v-model.number="original.Recargo", size="6", @focus="seleccionarTodo($event)", @keyup="calculaImportes")
									td
										input.inline(v-model.number="original.Descuento", size="6", @focus="seleccionarTodo($event)", @keyup="calculaImportes")
									td {{ original.ContenidoNombre }}
									td {{ original.ProgramaNombre }}
									td {{ original.HoraInicio }}
									td {{ original.HoraFin }}
									td {{ original.Posicion }}
									td {{ original.Fijar }}
									td.bg-danger.text-white {{ original.ImporteFinal | currency('')}} €
			.card-footer
				button.btn.btn-primary(@click="insertar")
					span.fa.fa-save.mr-2
					| Guardar
		ModalCalendario(v-if="definirFechas", :linea.sync="definirFechas", :contrato="contrato", @cerrar="definirFechas = null")
		Colocacion(v-if="colocando", :EmisoraID="linea.EmisoraID", :datos="originalSeleccionado" @colocacion="colocar($event)", @cerrar="colocando = null")
</template>

<script>
import Servicios from '../../../servicios.js'
import ModalCalendario from './modal-calendario'
import Colocacion from '../colocacion/colocacion.vue'
export default {
	props: ['linea', 'contrato'],
	components: {
		ModalCalendario,
		Colocacion
	},
	data () {
		return {
			filtro: {
				ClienteID: this.contrato.ClienteID,
				FechaDesde: new Date().setFullYear(new Date().getFullYear() - 1),
				FechaHasta: new Date(),
				Cadena: ''
			},
			listadoFicheros: [],
			originalSeleccionado: null,
			definirFechas: null,
			dias: [],
			colocando: null
		}
	},
	created () {
		this.buscarOriginales()
		window.addEventListener('keyup', this.teclaPulsada)
	},
	beforeDestroy () {
		window.removeEventListener('keyup', this.teclaPulsada)
	},
	methods: {
		buscarOriginales () {
			const form = JSON.parse(JSON.stringify(this.filtro))
			form.FechaDesde = this.$moment(this.filtro.FechaDesde).format('YYYY-MM-DD')
			form.FechaHasta = this.$moment(this.filtro.FechaHasta).format('YYYY-MM-DD')
			Servicios.GetOriginales(form)
				.then(listado => {
					this.listadoFicheros = listado
				})
				.catch(e => {
					console.error(e)
					this.$error('Error', e)
				})
		},
		agregarOriginal (fichero) {
			this.linea.originales.push({
				OriginalID: 'L-' + new Date().getTime() + Math.round(Math.random() * 10000),
				FicheroID: fichero.FicheroID,
				Descripcion: fichero.Nombre,
				UsuarioID: null,
				FechaCreacion: fichero.FechaCreacion,
				DuracionComercial: null,
				DuracionReal: fichero.FicheroDuracion,
				Importe: this.linea.ImporteBruto / this.linea.Cantidad,
				ImporteFinal: 0,
				Recargo: 0,
				Descuento: this.linea.Descuento,
				Inserciones: 1,
				ContenidoID: this.linea.ContenidoID,
				ContenidoNombre: this.linea.ContenidoNombre,
				ProgramaID: this.linea.ProgramaID,
				ProgramaNombre: this.linea.ProgramaNombre,
				HoraInicio: this.linea.HoraInicio,
				HoraFin: this.linea.HoraFin,
				dias: []
			})

			this.calculaImportes()
		},
		setFechas () {
			if (!this.originalSeleccionado) {
				return
			}
			this.definirFechas = this.originalSeleccionado
		},
		seleccionarTodo (e) {
			e.target.setSelectionRange(0, e.target.value.length)
		},
		setColocacion () {
			if (!this.originalSeleccionado) {
				return
			}
			this.colocando = this.originalSeleccionado
		},
		colocar (e) {
			for (let i = 0; i < this.linea.originales.length; i++) {
				if (this.linea.originales[i].OriginalID === this.originalSeleccionado.OriginalID) {
					this.linea.originales[i] = {...this.linea.originales[i], ...e}
				}
			}
		},
		teclaPulsada (e) {
			if (e.target.tagName === 'INPUT') {
				return
			}
			if (e.keyCode === 46 && this.originalSeleccionado) {
				e.preventDefault()
				e.stopPropagation()
				this.eliminarOriginal(this.originalSeleccionado)
			}
		},
		eliminarOriginal (original) {
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar original',
				mensaje: '¿Quieres eliminar este original de la lista?',
				callback: acepta => {
					if (acepta) {
						this.linea.originales = this.linea.originales.filter(o => o.OriginalID !== original.OriginalID)
						this.originalSeleccionado = null
					}
				}
			})
		},
		// Enviamos al padre todos los originales y sus fechas de inserción, así como el tramo horario
		insertar () {
			const inserciones = this.linea.originales.reduce((acc, o) => {
				for (let i in o.dias) {
					const ins = Servicios.NuevaInsercion(this.$moment(o.dias[i]).format('YYYY-MM-DD'))

					ins.FicheroID = o.FicheroID
					ins.Inserciones = o.Inserciones
					ins.Descripcion = o.Descripcion
					ins.Dia = this.$moment(o.dias[i]).format('YYYY-MM-DD')
					ins.DiaUnix = o.dias[i]
					ins.DuracionReal = o.DuracionReal
					ins.DuracionEstimada = o.DuracionComercial
					ins.Importe = o.Importe
					ins.ImporteUnitario = o.ImporteUnitario
					ins.ImporteFinal = o.ImporteFinal
					ins.Descuento = o.Descuento
					ins.ProgramaID = o.ProgramaID
					ins.ProgramaNombre = o.ProgramaNombre
					ins.ContenidoID = o.ContenidoID
					ins.ContenidoNombre = o.ContenidoNombre
					ins.HoraInicio = o.HoraInicio
					ins.HoraFin = o.HoraFin
					ins.Fijar = o.Fijar
					ins.RefExterna = o.RefExterna

					acc.push(ins)
				}
				return acc
			}, [])

			const total = inserciones.reduce((acum, ins) => {
				acum = acum + ins.Inserciones
				return acum
			}, 0)
			this.$store.commit('alertas/confirm', {
				titulo: 'Insertar originales',
				mensaje: `Vas a insertar un total de ${total} originales.
				¿Quieres continuar?`,
				callback: acepta => {
					if (acepta) {
						this.$emit('inserciones', inserciones)
						this.cerrar()
					}
				}
			})
		},
		calculaImportes () {
			for (let i = 0; i < this.linea.originales.length; i++) {
				const l = this.linea.originales[i]
				let importe = (isNaN(l.Importe)) ? 0 : l.Importe
				if (!isNaN(l.Descuento)) {
					importe = importe - (importe * l.Descuento / 100)
				}

				if (!isNaN(l.Recargo)) {
					importe = importe + l.Recargo
				}

				this.linea.originales[i].ImporteFinal = importe
			}
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>

<style scoped>

.contenedor {
	display: flex;
	flex-direction: row;
	width: 100%;
	align-content: stretch;
	align-items: stretch;
}
.contenedor > div {
	padding: 5px;
}
.barraLateral {
	display: flex;
	flex-direction: column;
	flex-grow: 0;
	flex-shrink: 0;
	flex-basis: 300px;
	border-right: 1px solid #e0e0e0;
	background-color: #f0f0f0;
}

.contieneFicheros {
	min-height: 400px;
	max-height: 400px;
	overflow-y: auto;
	overflow-x: hidden;
	background-color: white;
	margin: 0;
	padding: 0;
}

.contenidoCentral {
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	padding: 0 !important;
}

ul.barraOpciones {
	margin: 0;
	list-style: none;
	display: flex;
	flex-direction: row;
	width: 100%;
	align-content: flex-start;
	align-items: flex-start;
	padding: 0;
}
ul.barraOpciones > li {
	font-size: 2em;
	width: 40px;
	text-align: center;
	cursor: pointer;
}

ul.barraOpciones > li.disabled {
	font-size: 2em;
	width: 40px;
	text-align: center;
	cursor: pointer;
	opacity: 0.2;
	cursor: not-allowed;
}

ul.barraOpciones > li:hover {
	background-color: #f0f0f0;
}

table.tablaOriginales {
	position: relative;
	background-color: white;
	border-collapse: collapse;
	border: 0;
	border-top: 1px solid #e0e0e0;
	margin: 0;
	margin-left: 0px;
	margin-right: 0px;
	margin-bottom: -5px;
	padding: 0;
	width: 100%;
}
table > tbody > tr > td {
	border: 1px solid #e0e0e0;
	border-right: 0;
	border-left: 0;
}

table > thead > tr > th {
	text-align: right;
}
tr.filaOriginal > td {
	padding: 1px;
	border-right: 1px solid #e0e0e0;
	cursor: pointer;
	text-align: right;
}

tr.filaOriginal > td:last-of-type {
	padding: 1px;
	border-right: 0;
}

input.inline {
	border: 0;
	margin: 0;
	padding: 1px;
	text-align: right;
	background-color: rgba(0,0,0,0);
	width: 100%;
	display: block;
	position: relative;
	cursor: pointer;
}

input.inline:focus {
	border: none;
	outline: none;
}

.descripcion {
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/modulos/radiacion/vue/components/radiacion/insertar-originales/insertar-originales.vue